import * as React from "react";

import DataTable from "react-data-table-component-with-filter";
import { Link } from "react-router-dom";
import { RiFilterLine } from "react-icons/ri";

import Paper from "../../Components/Paper";
import Button from "../../Components/Button";
import FilterComponent from "../../Components/FilterComponent";
import { config } from "./Helper";
import { useLoader } from "../../Context/LoaderContext";
import { useConnectedUser } from "../../Context/ConnectedUserContext";
import axiosInstance from "../../Api/Axios";

import { handleDownload } from "../../Functions/Utils";

import Logo from "./../../Images/logo.png";
import "./ListReleaseRequests.scss";

const customStyles = {
  headCells: {
    style: {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      background: "#e75043",
      paddingBottom: "12px",
      paddingTop: "4px",
    },
  },
  cells: {
    style: {
      color: "#000",
      fontSize: "15px",
    },
  },
};

const ListReleaseRequests = () => {
  const [releaseRequests, setReleaseRequests] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [withFilter, setWithFilter] = React.useState(false);
  const { user } = useConnectedUser();

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/release-requests`)
      .then((response) => {
        setIsLoading(false);
        setReleaseRequests(response.data.data || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  const filteredItems = releaseRequests.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  const subHeaderComponent = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleDownloadPdf = () => {
    handleDownload("release_requests", "Demandes-de-mainlevee");
  };

  return (
    <Paper>
      <div className="wrap-tabs-offer">
        <h1>Demandes de mainlevée</h1>
        <div className="box_link_funding">
          <Link to="/release-requests/add-release-requests">
            <Button variant="dark">Déposez votre demande</Button>
          </Link>
        </div>
        {releaseRequests.length > 0 && (
          <div className="wrap-btn-action">
            <Button variant="dark" view="outline" onClick={handleDownloadPdf}>
              Imprimer
            </Button>
            <Button
              onClick={() => setWithFilter((prev) => !prev)}
              variant="dark"
              view="outline"
            >
              {withFilter ? "Masquer filtre" : "Afficher filtre"}
              <RiFilterLine />
            </Button>
          </div>
        )}
        <div className="print-container">
          <div className="entete-print ">
            <table cellPadding={10}>
              <tr>
                <td className="text-center">
                  {" "}
                  <img
                    src={Logo}
                    alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <b>{user.name}</b>{" "}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <DataTable
            // title="Demandes d’autorisation de quitter le territoire"
            columns={config(withFilter)}
            data={filteredItems}
            customStyles={customStyles}
            pagination
            subHeader
            highlightOnHover
            subHeaderComponent={subHeaderComponent}
            noDataComponent={<div> Pas d'informations disponibles</div>}
            paginationComponentOptions={{
              rowsPerPageText: "Lignes par page:",
              rangeSeparatorText: "de",
              noRowsPerPage: false,
              selectAllRowsItem: false,
              selectAllRowsItemText: "tous",
            }}
          />
        </div>
      </div>
    </Paper>
  );
};

export default ListReleaseRequests;
